import { render, staticRenderFns } from "./SCardBox.vue?vue&type=template&id=7c2d8ca2&scoped=true"
import script from "./SCardBox.vue?vue&type=script&lang=js"
export * from "./SCardBox.vue?vue&type=script&lang=js"
import style0 from "./SCardBox.vue?vue&type=style&index=0&id=7c2d8ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2d8ca2",
  null
  
)

export default component.exports